import React from 'react';
import { ChevronRight } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  size?: 'md' | 'lg' | 'xl';
}
export function Button({
  children,
  onClick,
  href,
  className = '',
  fullWidth = false,
  size = 'xl'
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center font-montserrat font-bold text-white bg-brand-red hover:bg-brand-darkRed transition-all duration-200 rounded-lg shadow-[0_4px_14px_0_rgba(220,38,38,0.39)] hover:shadow-[0_6px_20px_rgba(220,38,38,0.23)] hover:-translate-y-1 overflow-hidden group';
  const sizes = {
    md: 'px-6 py-3 text-lg',
    lg: 'px-8 py-4 text-xl',
    xl: 'px-10 py-5 text-2xl uppercase tracking-wide'
  };
  const width = fullWidth ? 'w-full' : '';
  const content = <>
      <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-white rounded-full group-hover:w-56 group-hover:h-56 opacity-10" data-id="element-51"></span>
      <span className="relative flex items-center gap-2 text-center" data-id="element-52">
        {children}
        <ChevronRight className="w-6 h-6 animate-pulse-fast" data-id="element-53" />
      </span>
    </>;
  if (href) {
    return <a href={href} className={`${baseStyles} ${sizes[size]} ${width} ${className}`} onClick={onClick} data-id="element-54">
        {content}
      </a>;
  }
  return <button onClick={onClick} className={`${baseStyles} ${sizes[size]} ${width} ${className}`} data-id="element-55">
      {content}
    </button>;
}